import { getLink } from "../../../utils/utils"

const content = {
	esp: (
		`
			<div style="text-align: justify;">
				<p class="mb-3">
					La lingvo Esperanto estis kreita en la jaro 1887. 
				</p>
				
				<p class="mb-3">
					Nu, kia banalaĵo, dirus vi. Kiu do tion ne scias?
				</p>
				
				<p class="mb-3">
					Sed ne tiel simple ĉio statas.
				</p>
				
				<p class="mb-3">
					La kreinto, ordinara pol-rusia kuracisto, neniam eĉ suspektinta pri la struktura lingvoscienco, semantiko, 
					aplikaj lingvaj modeloj ktp, elpensis antaŭ 135 jaroj la skemon, 
					kongruantan laŭ iuj detaloj kun unu el la plej interesaj kaj perspektivaj modeloj de la moderna lingvoscienco.
				</p>
				
				<p class="mb-3">
					Temas pri la t.n. aplika modelo de universala lingvo, proponita de eminenta usona sciencisto S. Ŝaumjan. 
				</p>
				
				<p class="mb-3">
					La modelo entenas, interalie, la samajn erojn kiel la sistemo de la lingvo, inventita de Zamenhof: 
					la ŝanĝilojn de substantivoj kaj verboj, transformantajn ilin en aliajn multnombrajn vortojn, sam- aŭ alispecajn.
				</p>
				
				<p class="mb-3">
					Ekzemple, en la sistemo de Ŝaumjan: 
				</p>
				
				<p class="mb-3">
					INSTRUMENTIVO – la ŝanĝilo de verbo al ilo – 
				</p>
				
				<p class="mb-3 vm_step1">
					kongruas kun Esperanta sufikso –IL- 
				</p>
				
				<p class="mb-5 vm_step2">
					(haki-hakilo)
				</p>
				
				<p class="mb-3">
					LOKATIVO – la ŝanĝilo de verbo al loko – 
				</p>
				
				<p class="mb-3 vm_step1">
					sufikso –EJ-
				</p>
				
				<p class="mb-5 vm_step2">
					(dormi-dormejo)
				</p>
				
				
				<p class="mb-3">
					DIMINUTIVO – malgrandigilo – 
				</p>
				
				<p class="mb-3 vm_step1">
					Sufikso –ET-
				</p>
				
				<p class="mb-5 vm_step2">
					(Domo-dometo) ktp.
				</p>
				
				
				<p class="mb-3">
					La kvanto de tiaspecaj ŝanĝileroj, koincidaj kun Esperantaj sufiksoj, atingas en tiu sistemo proksimume 15.
				</p>
				
				<p class="mb-3">
					Kompreneble, krom tiuj, la sistemo de Ŝaumjan entenas ampleksan kaj vastan aparaton de aliuj igiloj kaj reiloj transformantajn vortojn, 
					kaj la menciita ŝanĝilaro estas nur parto de multnombra ilaro de Ŝaumjan’es sistemo, multeflanka kaj enumanta ĉiujn aspektojn de gramatiko, 
					eĉ ne uzatajn en Esperanto.
				</p>
				
				<p class="mb-3">
					La sistemo havas grandan signifon por la tuta lingvoscienco: 
					ĝi estas provo unuigi ĉion komunan en diversaj lingvoj de la mondo kaj esprimi tion per klaraj, koncizaj leĝoj, 
					evidentigante la strukturon taŭgan por ĉiuj lingvoj – la t.n. gramatikon de ”genotipa lingvo”.
				</p>
				
				<p class="mb-3">
					La genotipa lingvo, laŭ Ŝaumjan, estas universala semiotika sistemo, abstrakta skemo, respegulanta plej gravajn ecojn de ĉiuj lingvoj de la mondo.
				</p>
				
				<p class="mb-3">
					Estas atentinde, ke Ŝaumjan en sia libro tre detale pristudas la problemon de lingva realeco. 
					Li diras: ”La genotipa lingvo ekzistas objektive, sed ĝi ne estas donita al ni per rekta observo”. 
					Alidire, ĝi ekzistas nur ece, tamen ne ekzistas substrato por tiel abstrakta kaj ”netuŝebla” substanco kiel genotipa lingvo.
				</p>
				
				<p class="mb-5">
					Tiel diras la aŭtoro. ”La naciaj lingvoj estas nur projekcioj de universala lingvo”, - asertas li.
				</p>
				
				
				<p class="mb-3">
					Tamen, ĉu ne povas ekzisti unu lingvo, kiu posedus karakterizajn trajtojn de tutmonda lingvaro, sed evoluus laŭ siaj propraj leĝoj?
				</p>
				
				<p class="mb-3">
					Ni povas vidi, ke Esperanto sufiĉe bone kongruas kun la postuloj de Ŝaumjan’es sistemo: 
					ke la gramatiko de Esperanto estas tre simpla kaj tute taŭga por ĉiu popolo kaj lando.
				</p>
				
				<p class="mb-3">
					Jam multajn jarojn ekzistas Esperanto, kaj dume ĝi ne disfalis je multspecaj dialektoj: ne ekzistas ja Esperanto hungara, aŭ itala, aŭ rusa, 
					vjetnama, ĉina. Homoj de ĉiuj popoloj, malgraŭ sia etna diverseco, skribas kaj parolas la unusaman, solan Esperanton!
				</p>
				
				<p class="mb-3">
					Ĉu ne pruvas tio, ke reguloj de Esperanto kongruas kun fundamentaj reguloj de komuna konscio de homoj; ke tiuj reguloj estas bonakceptitaj de ĉiuj, 
					ĉar ili konvenas al ĉiuj? Ĉu ne ĝuste tion ni subkomprenas sub la nomo de ”Universala”, ”Monda” lingvo?
				</p>
				
				<p class="mb-3">
					La lingvo de Ŝaumjan havas specialan vortordon, tre ”strangan” por ni sintakson, komplikan por la unua rigardo, - sed ankaŭ ĝi esprimas nociojn, 
					kiuj estas komunaj al lingva konscio de la tuta homaro.
				</p>
				
				<p class="mb-3">
					En la unuaj paĝoj de sia libro Ŝaumjan enkondukas koncepton pri ”struktura identeco”, aŭ IZOMORFISMO. 
					Tiu vorto signifas la plej profundan similecon inter ekstere tute diversaj aĵoj. 
					Kiel ekzemplo, al ni estas proponitaj fizikaj osciloj: la mekanikaj, akustikaj, elektromagnetaj, fiziologiaj osciloj havas diversajn substratojn, 
					diversajn aspektojn, sed la saman naturon, esprimeblan en matematikaj ekvacioj.
				</p>
				
				<p class="mb-3">
					Do, ĉu ni ne rajtas aserti, ke la sama identeco ekzistas por la du lingvoj pritraktitaj, por la ”genotipa lingvo” kaj Esperanto?
				</p>
				
				<p class="mb-3">
					Se tiamaniere okazos, tio donos al ni rajton deklari, ke Esperanto estas ne nur frukto de genia inspiro, kiu bonvenis iam al la Majstro. 
					Ĝi estas ankaŭ science argumentita malkovro pri esencaj leĝoj de la lingvo ĝenerale.
				</p>
				
				<p class="mb-3">
					La malkovro estis dekomence absolute praktika, empiria, preskaŭ hazarda, - kaj nur poste ĝi ricevis sciencan bazon, venintan el tute neatendita fonto.
				</p>
				
				<p class="mb-3">
					Tio rememorigas al ni la eltrovon de Mendel, kiu malkovris la fundamentajn leĝojn de heredeco ĉe biologiaj estaĵoj, 
					simple kreskigante pizojn en la ĝardeneto de sia monaĥejo, kaj eĉ ne imaginte, kiajn gravajn fruktojn alportos tiuj pizetoj.
				</p>
				
				<p class="mb-3">
					Aŭ la malkovron de Mendeleev, kiu konstruis sian genian elementtabelon senrezerve praktike, surbaze de atompezoj; 
					kaj nur poste oni ekkomprenis kaj pruvis ĝian esencan verecon, esplorinte elektronajn tavolojn de atomo.
				</p>
				
				<p class="mb-3">
					La tri plejegaj malkovroj de nuntempo – ekkompreno pri la leĝoj de evoluanta vivnaturo, 
					de neorganika materio kaj de la lingvo – estis faritaj dekomence praktike, se tiel diri, perpalpe, 
					kaj iomtempe ili ekzistadis simple kiel hipotezoj bonfunkciantaj kaj oportune uzeblaj, ĝis kiam oni metis sub ilin teorian bazon, 
					pruvinte ke ili efektive estas la esencaj regularoj.
				</p>
				
				<p class="mb-3">
					Verdire, nur du malkovroj jam estas surbazigitaj; la tria ĝis nun ne estas ankoraŭ science argumentita.
				</p>
				
				<p class="mb-3">
					Tamen, ĉu ne venis jam la tempo por tio?
				</p>
				
				<p class="mb-3">
					Ĉu ne statas la afero tiel, ke Esperanto kiel komunikilo estas, malgraŭ sia estiminda aĝo, 
					la plej lasta kaj plej urĝe bezonata paŝo de la lingva evoluo?
				</p>
				
			</div>
		
		`
	)
}

const itemName = {
	esp: 'Pri izomorfismo'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp:{
		itemName: itemName.esp,
		itemContent: content.esp
	}
}
export default item;